<template>
  <ModuleWrapper
    :moduleId="moduleId"
    :image="imageSrcPath('assets/branding/button-card-color.svg')"
    title="Banners shared on stage"
    @initializeData="initializeData"
  >
    <template #main>
      <StudioSelect
        id="color-option-picker"
        label="Pick colors from"
        :options="[
          { value: 'Button Colors', label: 'Button Colors' },
          { value: 'Popup Colors', label: 'Popup Colors' }
        ]"
        size="small"
        orientation="horizontal"
        class="tw-mb-4"
        :value="selectedColorOption"
        @change="e => onSelectColorOption(e.target.value)"
      />
      <StudioToggleWithLabel
        id="lower-thirds-reverse-color-toggle"
        label="Reverse Colors"
        :checked="isColorReverseEnable"
        @update:checked="toggleColorReverse"
      />
    </template>
  </ModuleWrapper>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import ModuleWrapper from './ModuleWrapper.vue';

import { StudioSelect, StudioToggleWithLabel } from '@/studioComponents';

export default {
  name: 'LowerThirds',
  components: {
    ModuleWrapper,
    StudioSelect,
    StudioToggleWithLabel
  },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedColorOption: 'Button Colors',
      isColorReverseEnable: false,
      moduleData: {}
    };
  },
  created() {
    this.initializeData();
  },
  computed: {
    ...mapGetters('branding', {
      getInitialModuleData: 'getInitialModuleData'
    })
  },
  methods: {
    ...mapMutations('branding', ['setChangesMadeInThemeObj']),
    initializeData() {
      const moduleKeys = ['lower_third_background'];
      const { lower_third_background } = this.getInitialModuleData(moduleKeys);

      this.moduleData = {
        themePrimaryColor: 'var(--theme-primary-color)',
        themeSecondaryColor: 'var(--theme-secondary-color)',
        primaryTextColor: 'var(--primary-text-color)',
        secondaryTextColor: 'var(--secondary-text-color)',
        lowerThirdBackground: lower_third_background
      };

      this.setInitialDropDownState();
      this.setInitialSwitchState();
    },
    setInitialDropDownState() {
      const { lowerThirdBackground, themeSecondaryColor, secondaryTextColor, themePrimaryColor, primaryTextColor } =
        this.moduleData;

      if (lowerThirdBackground === themeSecondaryColor || lowerThirdBackground === secondaryTextColor) {
        this.selectedColorOption = 'Button Colors';
      } else if (lowerThirdBackground === themePrimaryColor || lowerThirdBackground === primaryTextColor) {
        this.selectedColorOption = 'Popup Colors';
      }
    },
    setInitialSwitchState() {
      const { lowerThirdBackground, secondaryTextColor, primaryTextColor } = this.moduleData;

      if (lowerThirdBackground === secondaryTextColor || lowerThirdBackground === primaryTextColor) {
        this.isColorReverseEnable = true;
      } else {
        this.isColorReverseEnable = false;
      }
    },
    getPayload() {
      const { secondaryTextColor, themeSecondaryColor, primaryTextColor, themePrimaryColor } = this.moduleData;
      let payload;

      if (this.selectedColorOption === 'Button Colors') {
        if (this.isColorReverseEnable) {
          payload = {
            lower_third_background: secondaryTextColor,
            lower_third_text_color: themeSecondaryColor
          };
        } else {
          payload = {
            lower_third_background: themeSecondaryColor,
            lower_third_text_color: secondaryTextColor
          };
        }
      } else if (this.selectedColorOption === 'Popup Colors') {
        if (this.isColorReverseEnable) {
          payload = {
            lower_third_background: primaryTextColor,
            lower_third_text_color: themePrimaryColor
          };
        } else {
          payload = {
            lower_third_background: themePrimaryColor,
            lower_third_text_color: primaryTextColor
          };
        }
      }
      return payload;
    },
    onSelectColorOption(selectedColorOption) {
      this.selectedColorOption = selectedColorOption;
      const payload = this.getPayload();
      this.setChangesMadeInThemeObj(payload);
    },
    toggleColorReverse(event) {
      const value = event.target.checked;
      this.isColorReverseEnable = value;
      const payload = this.getPayload();
      this.setChangesMadeInThemeObj(payload);
    }
  }
};
</script>

<style scoped lang="scss">
.description {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: rgba(28, 30, 31, 0.6);
}

.input-wrapper {
  display: flex;
  align-items: center;
}
</style>
